import Alpine from 'alpinejs'
import { roundNumber, formatNumberToEuro } from './utils'

export const initFinanceTool = (): void => {
    Alpine.data(
        'financeTool',
        (price: number, interestRate: number, formHandle: string, defaultDownPayment: number, defaultTerm: string, defaultFinalTerm: number) => ({
            price,
            interestRate,
            formHandle,
            isOpen: false,
            downPayment: defaultDownPayment,
            finalTerm: defaultFinalTerm,
            term: defaultTerm,
            activeStep: 0,
            formInitialized: false,
            leaseChoice: '',
            $downPayment: null,
            $term: null,
            $finalTerm: null,
            $leaseChoice: null,
            $monthlyRate: null,
            $carUrl: null,
            $form: null,
            init() {
                document.addEventListener('DOMContentLoaded', () => {
                    const e = new CustomEvent('finance-tool-init', {
                        detail: {
                            financialLease: this.formatNumberToEuro(this.financialLease),
                            leasePurchase: this.formatNumberToEuro(this.leasePurchase),
                        },
                    })
                    window.dispatchEvent(e)
                })

                document.addEventListener('onFormieInit', (e: CustomEvent) => {
                    if (e.detail.form.config.formHandle === this.formHandle) {
                        this.$form = e.detail.$form
                        this.$downPayment = this.$form.querySelector('[name="fields[downPayment]"]')
                        this.$term = this.$form.querySelector('[name="fields[term]"]')
                        this.$finalTerm = this.$form.querySelector('[name="fields[finalTerm]"]')
                        this.$leaseChoice = this.$form.querySelector('[name="fields[leaseChoice]"]')
                        this.$monthlyRate = this.$form.querySelector('[name="fields[monthlyRate]"]')
                        this.$carUrl = this.$form.querySelector('[name="fields[carUrl]"]')
                        this.setFinancialDataInUserForm()
                        this.formInitialized = true

                        this.$form.addEventListener('onAfterFormieSubmit', (e) => {
                            if (e.detail.success) {
                                this.nextStep()
                            }
                        })
                    }
                })
            },
            open() {
                this.isOpen = true
            },
            close(reset = false) {
                this.isOpen = false

                if (reset || this.activeStep === 2) {
                    this.reset()
                }
            },
            get financialLease(): number {
                return this.calculateMonthlyPayment(false)
            },
            get leasePurchase(): number {
                return this.calculateMonthlyPayment(true)
            },
            get vehiclePrice(): number {
                return this.price
            },
            calculateMonthlyPayment(leasePurchase = false): number {
                //Calculate monthly rate
                const monthlyRate = leasePurchase ? roundNumber(100 * (Math.pow(this.interestRate / 100 + 1, 1 / 12) - 1), 8) : this.interestRate / 12

                // Calculate principal (loan amount)
                const principal = this.price - this.downPayment

                // Calculate PMT (Payment) using financial formula
                // PMT = (P - FV/(1+r)^n) * (r * (1 + r)^n) / ((1 + r)^n - 1)
                // where:
                // P = principal
                // FV = future value (balloon payment)
                // r = interest rate per period (monthlyRate/100)
                // n = number of payments (term)
                const rate = monthlyRate / 100
                const payments = parseInt(this.term)
                const futureValue = this.finalTerm

                const monthlyPayment =
                    ((principal - futureValue / Math.pow(1 + rate, payments)) * (rate * Math.pow(1 + rate, payments))) /
                    (Math.pow(1 + rate, payments) - 1)

                return monthlyPayment ? Math.round(monthlyPayment) : 0
            },
            continueToUserData(leaseChoice) {
                this.leaseChoice = leaseChoice

                if (this.formInitialized) {
                    this.setFinancialDataInUserForm()
                }

                this.nextStep()
            },
            setFinancialDataInUserForm() {
                if (this.$downPayment) this.$downPayment.value = this.formatNumberToEuro(this.downPayment)
                if (this.$term) this.$term.value = this.term
                if (this.$finalTerm) this.$finalTerm.value = this.formatNumberToEuro(this.finalTerm)
                if (this.$leaseChoice) this.$leaseChoice.value = this.leaseChoice
                if (this.$carUrl) this.$carUrl.value = window.location.href

                if (this.$monthlyRate) {
                    if (this.leaseChoice === 'financial_lease') {
                        this.$monthlyRate.value = this.formatNumberToEuro(this.financialLease)
                    }
                    if (this.leaseChoice === 'lease_purchase') {
                        this.$monthlyRate.value = this.formatNumberToEuro(this.leasePurchase)
                    }
                }
            },
            reset() {
                this.leaseChoice = ''
                this.downPayment = defaultDownPayment
                this.finalTerm = defaultFinalTerm
                this.term = defaultTerm
                this.activeStep = 0
                this.$form.reset()
            },
            nextStep() {
                this.activeStep++
            },
            previousStep() {
                this.activeStep--
            },
            formatNumberToEuro(price) {
                return formatNumberToEuro(price)
            },
        })
    )
}
